/******************************************************************************************
 *	Cancel PA Modal for SLS 2.3 changes
 ******************************************************************************************/
(function () {
  angular
    .module('rcControllers.newCancelPaModal', [])
    .factory(
      'NewCancelPaModal',
      /* @ngInject */
      function (modal) {
        return modal({
          templateUrl: 'views/partials/modals/cancel-pa-modal.html',
          controller: 'NewCancelPaModalController',
          classNames: 'cancel-pa-modal'
        });
      }
    )
    .controller(
      'NewCancelPaModalController',
      /* @ngInject */
      function (
        _,
        $log,
        $scope,
        NewCancelPaModal,
        Orders,
        CurtainNotifications
      ) {

        var submitSuccessful = function (responseData) {
          CurtainNotifications.show(
            CurtainNotifications.INFO,
            'cancelPaModal.notifications.cancellationInProgress'
          );
          NewCancelPaModal.remove({
            response: responseData
          });
        };

        $scope.submit = function () {
          if (!$scope.submitted) {
            let shortenedMarketSegment;
            $scope.submitted = true;
            NewCancelPaModal.setLoadingState();

            if ($scope.marketSegment) {
              if ($scope.marketSegment === 'COMMERCIAL') {
                shortenedMarketSegment = 'COM';
              } else if($scope.marketSegment === 'GOVERNMENT') {
                shortenedMarketSegment = 'GOV';
              } else {
                shortenedMarketSegment = 'EDU';
              }
            }

            Orders.cancelPA({
                customerId: $scope.customerID,
                contractId: $scope.contractId,
                customerCountry: $scope.customerCountry,
                cancellableItems: $scope.cancellableItems,
                marketSegment: shortenedMarketSegment
              })
              .then(submitSuccessful)
              .catch(function (res) {
                if (res) {
                  NewCancelPaModal.unsetLoadingState();
                  CurtainNotifications.show(
                    CurtainNotifications.ERROR,
                    'generic.notifications.error'
                  );
                  $log.error('Failed to cancel the invite (non-CCS)', res.response.data.message);
                  NewCancelPaModal.remove({
                    response: res
                  });
                }
              });
          }
        };

        //Close modal
        $scope.removeModal = function () {
          //Closing the modal via the "X" or "Cancel" buttons will resolve the promise with an object containing a true `cancelled` property
          NewCancelPaModal.remove({
            cancelled: true
          });
        };
      }
    );
})();
